const DataTableColumnHeaderWrap = ({ title }: { title: string }) => {
    return (
        <div className="break-words whitespace-normal text-center">
            <span className="line-clamp-2">{title}</span>
        </div>
    );
};

export default DataTableColumnHeaderWrap;
